/**
 * WoShop — revelado al hacer scroll.
 * Añade .is-visible a los elementos .ws-reveal cuando entran en viewport.
 * Sin dependencias. Si no hay IntersectionObserver (o el usuario pidió menos
 * movimiento), los elementos quedan visibles sin animación.
 */
(function () {
  function revealAll(elements) {
    elements.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function init() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('.ws-reveal:not(.is-visible)'));
    if (elements.length === 0) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || typeof IntersectionObserver === 'undefined') {
      revealAll(elements);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas re-renderiza secciones sin recargar la página.
  document.addEventListener('shopify:section:load', init);
})();
